<template>
  <div class="login-form">
    <div class="login-card">
      <div class="card-title">
        <h1>
          <a href="/">
            <img
              src="static/kithara.svg"
              alt="Kithara"
              width="112"
              height="28"
            >
          </a>
        </h1>
      </div>
      <div class="content">
        <article
          v-if="!error && $route.query.redirect"
          class="message is-info"
        >
          <div class="message-body">
            You need to login first.
          </div>
        </article>
        <article
          v-if="error"
          class="message is-danger"
        >
          <div class="message-body">
            Error: {{ error }}
          </div>
        </article>
        <form @submit.prevent="login">
          <input
            v-model="credentials.username"
            placeholder="Username"
            type="text"
            required
            autofocus
          >
          <input
            v-model="credentials.password"
            placeholder="Password"
            type="password"
            required
          >
          <!-- <div class="level options">
            <div class="checkbox level-left">
              <input type="checkbox" id="checkbox" class="regular-checkbox">
              <label for="checkbox"></label>
              <span>Remember me</span>
            </div>
            <a class="btn btn-link level-right" href="#">Forgot Password?</a>
          </div> -->
          <button
            type="submit"
            class="btn btn-primary"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        username: "",
        password: ""
      },
      error: undefined
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch("login", this.credentials)
        .then(() => this.$router.push(this.$route.query.redirect || "/"))
        .catch(e => (this.error = e.response.data.message));
    },
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style lang="scss">
$primary: hsl(171, 100%, 41%);
$grey-darker: hsl(0, 0%, 21%);
$grey-dark: hsl(0, 0%, 29%);
$grey: hsl(0, 0%, 48%);
$grey-light: hsl(0, 0%, 71%);
$grey-lighter: hsl(0, 0%, 86%);

.login-form {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f7f7f7;

  .login-card {
    background: #fff;
    width: 24rem;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);

    .card-title {
      background-color: darken($primary, 5%);
      padding: 2rem;

      h1 {
        color: #fff;
        text-align: center;
        font-size: 1.2rem;
      }
    }

    .content {
      padding: 2rem 2.5rem 3rem;
    }

    input[type="text"],
    input[type="password"] {
      display: block;
      width: 100%;
      font-size: 1rem;
      margin-bottom: 1.75rem;
      padding: 0.25rem 0;
      border: none;
      border-bottom: 1px solid $grey-lighter;
      transition: all 0.5s;

      &:hover {
        border-color: $grey;
      }

      &:active,
      &:focus {
        border-color: $primary;
      }
    }

    .checkbox {
      color: $grey-light;
      font-size: 0.8rem;

      span {
        margin-left: 0.5rem;
      }
    }

    a {
      font-size: 0.8rem;
    }

    .options {
      color: $grey-light;
      margin-bottom: 1.5rem;
    }

    button {
      cursor: pointer;
      font-size: 1.2rem;
      color: $primary;
      border-radius: 4rem;
      display: block;
      width: 100%;
      background: transparent;
      border: 2px solid $primary;
      padding: 0.9rem 0 1.1rem;
      transition: color 0.5s, border-color 0.5s;

      &:hover,
      &:focus {
        color: darken($primary, 10%);
        border-color: darken($primary, 10%);
      }

      &:active {
        transform: translateY(1px);
      }
    }
  }
}

label {
  cursor: pointer;
}

.regular-checkbox {
  display: none;
}

.regular-checkbox + label {
  background-color: #fafafa;
  border: 1px solid $grey-lighter;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  padding: 7px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
}

.regular-checkbox:checked + label {
  background-color: #e9ecee;
}

.regular-checkbox:checked + label:after {
  content: "\2714";
  font-size: 11px;
  position: absolute;
  top: 0;
  left: 3px;
  color: $grey-light;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// Login.vue?01ccc867